import styled from "styled-components";

export const EventFormColumns = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: ${({ theme }) => theme.spacing(0)};
	column-gap: ${({ theme }) => theme.spacing(12)};

	${({ theme }) => theme.breakpoints.tablet} {
		grid-template-columns: 1fr 1fr;
	}
`;
